SCHEMAS =
  subject: [
    {
      "id": "subject.first_name",
      "label": "First name",
      "description": "First name of subject",
      "required": true
    },
    {
      "id": "subject.country",
      "label": "Country",
      "description": "Country of subject",
      "required": true
    },
    {
      "id": "subject.metadata",
      "label": "Metadata",
      "description": "Metadata of subject",
      "required": true,
      "multiple": true
    }
  ]

TEMPLATES =
  subject: """
{
    "subject.first_name": {
        "fields": [
            [
                "{{ selections['subject.first_name'] }}"
            ]
        ],
        "template": "{}"
    },
    "subject.country": {
        "fields": [
            "{{ selections['subject.country'] }}"
        ],
        "template": "{}"
    },
    "subject.metadata": {
        "fields": {{ selections['subject.metadata'] }},
        "template": "{}"
    }
}
  """

angular.module("workflow.app")
  .factory "bulkUploadGeneratorData", () ->
    return {
      getSchema: (mappingType) ->
        return SCHEMAS[mappingType]

      getTemplate: (mappingType) ->
        return TEMPLATES[mappingType]
    }
